<template>
    <div>
      <!--面包屑导航区域-->
      <el-breadcrumb separator-class="el-icon-arrow-right" class="bread">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>卖家地址管理</el-breadcrumb-item>
        <el-breadcrumb-item>地址信息</el-breadcrumb-item>
      </el-breadcrumb>
      <!--编辑地址-->
      <el-dialog title="编辑地址" width="500px"  :visible.sync="dialogFormVisible">
        <el-form :model="addressForm" class="editAddressForm">
          <el-form-item label="商家名" :label-width="formLabelWidth">
            <el-input v-model="addressForm.receiverName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="商家电话" :label-width="formLabelWidth">
            <el-input v-model="addressForm.receiverPhone" maxlength="11" show-word-limit autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="所在省份" :label-width="formLabelWidth">
            <el-select v-model="addressForm.receiverProvince" @change="selectProvince" placeholder="请选择省份">
              <el-option v-for="province in addressListJson"  :key="province.name" :label="province.name" :value="province.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在城市" :label-width="formLabelWidth">
            <el-select v-model="addressForm.receiverCity" @change="selectCity" placeholder="请选择城市">
              <el-option v-for="city in provinceList" :key="city.name" :label="city.name" :value="city.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在区/县" :label-width="formLabelWidth">
            <el-select v-model="addressForm.receiverDistrict" placeholder="请选择地区">
              <el-option v-for="area in areaList" :key="area" :label="area" :value="area">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址" :label-width="formLabelWidth">
            <el-input v-model="addressForm.receiverAddress" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="updateAddressCancel">取 消</el-button>
          <el-button type="primary" @click="updateAddress">确 定</el-button>
        </div>
      </el-dialog>

      <!--新增地址-->
      <el-button class="add-btn" @click="addAddress" type="primary" icon="el-icon-circle-plus">新增地址</el-button>

      <el-table class="address-list" :data="addressList.slice((currentPage-1) * pageSize,currentPage * pageSize)" stripe border>
        <el-table-column prop="id" label="地址编号" align="center"></el-table-column>
        <el-table-column prop="userId" label="商家用户名" align="center"></el-table-column>
        <el-table-column prop="receiverName" label="商家名" align="center"></el-table-column>
        <el-table-column prop="receiverPhone" label="商家电话" align="center"></el-table-column>
        <el-table-column prop="receiverProvince" label="商家省份" align="center"></el-table-column>
        <el-table-column prop="receiverCity" label="商家城市" align="center"></el-table-column>
        <el-table-column prop="receiverDistrict" label="商家地区" align="center"></el-table-column>
        <el-table-column prop="receiverAddress" label="商家详细地址" align="center"></el-table-column>
        <el-table-column label="操作" width="200px" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="editAddress(scope.row)">编辑</el-button>
            <el-button type="danger" @click="deleteAddress(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
</template>

<script>
const request = require('./../../http/address')
const addressJson = require('./../../assets/json/address.json')
export default {
  name: 'addressList',
  mounted () {
    this.getAddressList()
  },
  data () {
    return {
      addressListJson: addressJson,
      provinceList: [], // 省份列表
      cityList: [], // 城市表
      areaList: [], // 地区表
      addressList: [], // 用户地址列表
      currentPage: 1, // 初始页
      pageSize: 6, //    每页的数据
      dialogFormVisible: false, // 控制对话框的可不可见
      addressForm: {
        id: '', // 商家编号
        receiverName: '', // 商家名
        receiverPhone: '', // 商家电话
        receiverProvince: '', // 商家所在省份
        receiverCity: '', // 商家所在城市
        receiverDistrict: '', // 商家所在区县
        receiverAddress: '' // 商家详细地址
      },
      formLabelWidth: '120px'
    }
  },
  methods: {
    handleSizeChange (size) { // pageSize改变时触发
      this.pageSize = size
    },
    handleCurrentPage (currentPage) { // 当前页面改变时触发
      this.currentPage = currentPage
    },
    async deleteAddress (row) { // 删除地址
      let data = {
        id: row.id
      }
      let deleteAddressRes = await request.deleteAddress(data)
      if (deleteAddressRes.data.message === '成功') {
        this.$message({
          message: '删除地址成功',
          type: 'success'
        })
      } else {
        this.$message.error('删除地址失败')
      }
      await this.getAddressList()
    },
    updateAddressCancel () {
      this.dialogFormVisible = false
      this.getAddressList()
    },
    async updateAddress () { // 上传编辑地址
      let data = {
        id: this.addressForm.id,
        receiverAddress: this.addressForm.receiverAddress,
        receiverCity: this.addressForm.receiverCity,
        receiverDistrict: this.addressForm.receiverDistrict,
        receiverName: this.addressForm.receiverName,
        receiverPhone: this.addressForm.receiverPhone,
        receiverProvince: this.addressForm.receiverProvince
      }
      this.$router.push({
          path: '../../boss/BussinessOrder.vue',
          name: 'addressId',
          query: { id: this.addressForm.id }
      })
      let res = await request.updateAddress(data)
      if (res.data.message === '成功') {
        this.$message({
          message: '修改地址成功',
          type: 'success'
        })
        this.dialogFormVisible = false
      } else {
        this.$message.error('修改地址失败')
        this.dialogFormVisible = false
      }
      this.getAddressList()
    },
    editAddress (row) { // 编辑地址
      // console.log(row)
      this.dialogFormVisible = true
      this.addressForm = row
    },
    addAddress () { // 跳转到新增地址页
      this.$router.push('/addAddress')
    },
    async getAddressList () { // 获取地址列表
      let data = {
        pages: this.currentPage,
        limit: this.pageSize
      }
    //   console.log(data)
      let addressRes = await request.getAddressList(data)
      this.addressList = addressRes.data.data.list
    },
    selectProvince (e) { // 选择省份
      this.addressForm.receiverCity = ''
      this.addressForm.receiverDistrict = ''
      this.addressForm.receiverAddress = ''
      for (let i = 0; i < this.addressListJson.length; i++) {
        if (this.addressListJson[i].name === e) {
          this.provinceList = this.addressListJson[i].city
          break
        }
      }
    },
    selectCity (e) { // 选择城市
      for (let i = 0; i < this.provinceList.length; i++) {
        if (this.provinceList[i].name === e) {
          this.areaList = this.provinceList[i].area
          break
        }
      }
    }
  }
}
</script>

<style scoped>
  .add-btn{
    margin-top: 10px;
  }
  .address-list{
    width: 100%;
    margin-top: 20px;
  }
  .editAddressForm{
    width: 400px;
  }
</style>
